import { AxiosRequestConfig, AxiosResponse, isAxiosError } from "axios";
import { client } from "./client";
import { setSaveTemplateState } from "@/store/app/slice";
import { store } from "@/store/store";
import { SaveTemplateState } from "@/types/app";
import { getIsProductionEnv } from "@/utils/env";

export async function apiRequest<T>(
    url: string,
    method: string,
    params?: any,
    headers?: any,
    responseType?: any,
    signal?: AbortSignal,
): Promise<T> {
    const isProduction = getIsProductionEnv();
    const config: AxiosRequestConfig = {
        url,
        method,
        params: method.toUpperCase() === "GET" ? params : undefined, // Use 'params' for GET requests
        data: method.toUpperCase() !== "GET" ? params : undefined,
        headers,
        responseType,
        signal,
    };
    const isUpdatingTemplate =
        url.includes("resume") &&
        (method === "POST" || method === "PATCH") &&
        !url.includes("smart-match");
    const currentSaveTemplateState = store.getState().app.saveTemplateState;

    if (
        isUpdatingTemplate &&
        currentSaveTemplateState !== SaveTemplateState.SAVING
    ) {
        store.dispatch(setSaveTemplateState(SaveTemplateState.SAVING));
    }

    try {
        const response: AxiosResponse<T> = await client(config);
        if (isUpdatingTemplate) {
            store.dispatch(setSaveTemplateState(SaveTemplateState.SAVED));
        }
        return response.data;
    } catch (error) {
        if (
            isUpdatingTemplate &&
            currentSaveTemplateState !== SaveTemplateState.ERROR
        ) {
            store.dispatch(setSaveTemplateState(SaveTemplateState.ERROR));
        }
        if (isAxiosError(error)) {
            // Access to config, request, and response
            const errorMessage = error.response?.data.message;
            if (!isProduction) {
                console.error("[DEBUG] errorMessage:", errorMessage);
            }
            throw new Error(errorMessage);
        } else {
            if (!isProduction) {
                console.error("[DEBUG] useApi Error:", error);
            }
            throw new Error("Unexpected Error!");
        }
    }
}
